/* eslint-disable react/jsx-curly-brace-presence */
import React, { FC } from 'react';
import { Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import WizardContent from '~/layouts/WizardContent';
import features from '~/constants/features';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import theme from '~/constants/theme';
import { SalesforceHardDeclineImg } from '~/img';

const SalesforceHardDecline: FC = () => {
  const { t } = useTranslation('stageResult');

  return (
    <WizardContent
      content={
        <Container className="SalesforceHardDecline">
          <div className="SalesforceHardDecline-Content">
            <SalesforceHardDeclineImg className="SalesforceHardDecline-Img" />
            <h3 className="SalesforceHardDecline-Title">
              {t("We regret to inform you that your application was unsuccessful. We appreciate your interest and thank you for considering the Network Corporate Card.")}
            </h3>
            <Typography.Paragraph className="SalesforceHardDecline-Paragraph">
              <p>
                <Trans t={t} i18nKey="If you wish to discuss with us, please <1>contact us</1>.">
                  {'If you wish to discuss with us, please '}
                  <a href={features.contactUsLinkHardDecline} target="__blank">
                    contact us
                  </a>
                  .
                </Trans>
              </p>
            </Typography.Paragraph>
          </div>
          <div className="SalesforceHardDecline-ContactUs">
            <BottomLeftActions contactUsUrl={features.contactUsLinkHardDecline} contactUsTextPosition="left" />
          </div>
        </Container>
      }
    />
  );
};

const Container = styled.div`
  .SalesforceHardDecline-Content {
    position: relative;
    .SalesforceHardDecline-Img {
      width: 100%;
      margin-bottom: 32px;
    }
    .SalesforceHardDecline-Title {
      position: absolute;
      top: 10%;
      left: 5%;
      width: 50%;
      color: #0060a8;
    }
    .SalesforceHardDecline-Paragraph {
      margin-left: 5%;
    }
    @media (max-width: ${theme.breakpoints.md}px) {
      .SalesforceHardDecline-Title {
        position: static;
        width: 100%;
        border-radius: ${theme.borderRadiusBase}px;
      }
      .SalesforceHardDecline-Img {
        border-radius: ${theme.borderRadiusBase}px;
      }
      .SalesforceHardDecline-Paragraph {
        margin-left: 0;
      }
    }
  }
  .SalesforceHardDecline-ContactUs {
    position: absolute;
    bottom: 40px;
    right: 40px;
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    .SalesforceHardDecline-ContactUs {
      display: none;
    }
  }
`;

export default SalesforceHardDecline;
